<template>
  <el-dialog @open="iniciar" :title="dialogTitle" :visible.sync="visibility" :before-close="cancelar" :close-on-click-modal="false" append-to-body width="50%" v-loading="isLoading">
    <div class="scrollable" style="height: 500px">
      <el-form ref="form" label-position="top" size="small" :model="usuario" :rules="formRules" hide-required-asterisk :show-message="false">
        <div style="color: #777; font-weight: bold; font-size: 15px">
          <i class="el-icon-document" />
          Informações da Conta
        </div>
        <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 5px">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item prop="login" label="Login">
                <el-input v-model="usuario.login" v-mask="'###.###.###-##'" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="perfil" label="Tipo">
                <el-select v-model="usuario.perfil" value-key="data" placeholder="Selecione" style="width: 100%">
                  <el-option value="ADMINISTRADOR" label="Administrador" />
                  <el-option value="GERENTE" label="Gerente" />
                  <el-option value="CORRETOR" label="Corretor" />
                  <el-option value="SECRETARIO" label="Secretário" />
                  <el-option value="PARCEIRO" label="Parceiro" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="Senha" prop="senha">
                <el-input v-model="usuario.senha" type="password" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Confirme a Senha" prop="confirmacaoSenha">
                <el-input v-model="usuario.confirmacaoSenha" type="password" />
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="Email">
                <el-input v-model="usuario.email" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div style="color: #777; font-weight: bold; font-size: 15px; margin-top: 10px">
          <i class="el-icon-user" />
          Informações do Usuário
        </div>
        <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 5px">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item prop="nome" label="Nome">
                <el-input v-model="usuario.nome" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="CPF">
                <el-input readonly v-model="usuario.login" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Data de Nascimento">
                <el-date-picker
                  v-model="usuario.dataNascimento"
                  v-mask="'##/##/####'"
                  type="date"
                  format="dd/MM/yyyy"
                  value-format="dd/MM/yyyy"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="Creci">
                <el-input v-model="usuario.creci" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Comissão">
                <div class="el-input el-input--small">
                  <money v-model="usuario.comissao" v-bind="percentFormat" class="el-input__inner" />
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :md="12" :lg="12">
              <el-form-item label="Telefone">
                <el-input
                  v-model="usuario.telefone"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                />
              </el-form-item>
            </el-col>
            <el-col :md="12" :lg="12">
              <el-form-item label="Celular">
                <el-input
                  v-model="usuario.celular"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div style="color: #777; font-weight: bold; font-size: 15px; margin-top: 10px">
          <i class="el-icon-location" />
          Endereço
        </div>
        <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 5px">
          <el-row :gutter="10">
            <el-col :span="18">
              <el-form-item label="Endereço">
                <el-input v-model="usuario.endereco" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Número">
                <el-input v-model="usuario.numeroEndereco" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="18">
              <el-form-item label="Complemento">
                <el-input v-model="usuario.complemento" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="CEP">
                <el-input v-model="usuario.cep" v-mask="'#####-###'" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="4">
              <el-form-item label="UF">
                <el-select v-model="usuario.estado" value-key="id" placeholder="" filterable clearable style="width: 100%">
                  <el-option v-for="estado in estados" :key="estado.id" :value="estado" :label="estado.sigla" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="Cidade">
                <el-input v-model="usuario.cidade" />
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="Bairro">
                <el-input v-model="usuario.bairro" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div style="color: #777; font-weight: bold; font-size: 15px; margin-top: 10px">
          <i class="el-icon-time" />
          Horários de Acesso
        </div>
        <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 5px">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="Dia da Semana">
                <el-select v-model="horarioAcesso.diaDaSemana" value-key="data" placeholder="Selecione" style="width: 100%">
                  <el-option v-for="dias in diasSemana" :key="dias.data" :value="dias.data" :label="dias.label" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="Horário">
                <el-input v-model="horarioAcesso.horarioInicio" v-mask="'##:##'">
                  <template slot="suffix">à</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label=" ">
                <el-input v-model="horarioAcesso.horarioFim" v-mask="'##:##'" />
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label=" ">
                <el-button
                  @click="addHorarioAcesso"
                  title="Adicionar"
                  type="success"
                  icon="el-icon-plus"
                  size="mini"
                  circle />
              </el-form-item>
            </el-col>
          </el-row>

          <el-table :data="usuario.horariosDeAcesso">
            <el-table-column label="Dia da Semana">
              <template slot-scope="scope">
                <span style="font-weight: bold">
                  {{ util.getLabel(diasSemana, scope.row.diaDaSemana) }}
                </span>
              </template>
            </el-table-column>

            <el-table-column label="Horário">
              <template slot-scope="scope">
                <span style="font-weight: bold">
                  {{ `${scope.row.horarioInicio} - ${scope.row.horarioFim}` }}
                </span>
              </template>
            </el-table-column>

            <el-table-column>
              <template slot-scope="scope">
                <el-button
                  @click="removerHorarioAcesso(scope.row)"
                  title="Remover"
                  type="text"
                  size="medium"
                >
                  <i class="el-icon-delete icone-remover" />
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
    </div>
    <span slot="footer">
      <el-button @click="clickBotaoGravar" size="mini" type="success">
        Gravar
      </el-button>
      <el-button @click="clickBotaoFechar" size="mini" type="danger">
        Fechar
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Money } from 'v-money';
import { ESTADOS, DIAS_DA_SEMANA } from '../util/constantes';
import Util from '../util/funcoes';
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    visibility: Boolean,
    idUsuario: Number,
    idImobiliaria: Number,
  },

  components: {
    Money,
  },

  data() {
    return {
      usuario: {
        login: '',
        perfil: 'ADMINISTRADOR',
        senha: '',
        confirmacaoSenha: '',
        email: '',
        nome: '',
        dataNascimento: '',
        creci: '',
        comissao: 0,
        telefone: '',
        celular: '',
        endereco: '',
        numeroEndereco: '',
        complemento: '',
        cep: '',
        estado: { id: 0, nome: '' },
        cidade: '',
        bairro: '',
        horariosDeAcesso: [],
        permissoes: [],
      },

      horarioAcesso: {
        diaDaSemana: '',
        horarioInicio: '',
        horarioFim: '',
      },

      percentFormat: {
        decimal: ',',
        thousands: '.',
        suffix: ' %',
        precision: 2,
        masked: false
      },
    };
  },

  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),

    estados() {
      return ESTADOS;
    },

    diasSemana() {
      return DIAS_DA_SEMANA;
    },

    util() {
      return Util;
    },

    isCadastrando() {
      return this.idUsuario === 0;
    },
    isEditando() {
      return this.idUsuario !== 0;
    },

    dialogTitle() {
      if(this.isCadastrando) {
        return 'Adicionar Usuário';
      }

      return 'Editar Usuário';
    },

    formRules() {
      if(this.idUsuario === 0) {
        return {
          login: [{ required: true }],
          perfil: [{ required: true }],
          senha: [{ required: true }],
          confirmacaoSenha: [{ required: true }],
          nome: [{ required: true }]
        }
      } else {
        return {
          login: [{ required: true }],
          perfil: [{ required: true }],
          nome: [{ required: true }]
        }
      }
    }
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading',
    ]),

    ...mapActions('imobiliariasStore', {
      'gravarUsuarioAction': 'gravarUsuario',
      'recuperarUsuarioAction': 'recuperarUsuario',
    }),

    clickBotaoGravar() {
      this.$refs.form.validate(isValid => {
        if(!isValid) {
          this.exibirAlerta('Preencha todos os campos obrigatórios');
          return;
        }

        if((this.usuario.senha && this.usuario.senha.trim() !== '' && this.usuario.confirmacaoSenha && this.usuario.confirmacaoSenha.trim() !== '') && (this.usuario.senha !== this.usuario.confirmacaoSenha)) {
          this.exibirAlerta('As senhas não conferem');
          return;
        }

        this.gravarUsuario();
      });
    },

    exibirAlerta(mensagem) {
      this.$alert(mensagem, 'Atenção', {
        confirmButtonText: 'OK',
        type: 'warning',
      });
    },

    getPayload() {
      const payload = {
        ...this.usuario,
        imobiliaria: {
          id: this.idImobiliaria,
        },
      };

      delete payload.confirmacaoSenha;

      return payload;
    },

    gravarUsuario() {
      const payload = this.getPayload();

      this.showLoading();
      
      this.gravarUsuarioAction(payload)
        .then(resultado => {
          switch(resultado.status) {
            case 'SUCESSO':
              this.$message.success(resultado.mensagem);
              this.$emit('gravar');
          }
        })
        .catch()
        .finally(() => {
          this.hideLoading();
        })
    },

    clickBotaoFechar() {
      this.close();
    },

    iniciar() {
      this.reset();
      if(this.isEditando) {
        this.recuperarUsuarioEPreencherFormulario();
      }
    },

    recuperarUsuarioEPreencherFormulario() {
      const payload = {
        id: this.idUsuario,
      };

      this.showLoading();

      this.recuperarUsuarioAction(payload)
        .then(resultado => {
          switch(resultado.status) {
            case 'SUCESSO':
              this.preencherFormulario(resultado.item);
          }
        })
        .catch()
        .finally(() => {
          this.hideLoading();
        });
    },

    preencherFormulario(usuario) {
      this.usuario = {
        ...usuario,
      };
    },

    reset() {
      this.resetFormUsuario();
    },

    resetFormUsuario() {
      this.usuario = {
        login: '',
        perfil: 'ADMINISTRADOR',
        senha: '',
        confirmacaoSenha: '',
        email: '',
        nome: '',
        dataNascimento: '',
        creci: '',
        comissao: 0,
        telefone: '',
        celular: '',
        endereco: '',
        numeroEndereco: '',
        complemento: '',
        cep: '',
        estado: { id: 0, nome: '' },
        cidade: '',
        bairro: '',
        horariosDeAcesso: [],
        permissoes: [],
      };
    },

    addHorarioAcesso() {
      this.horarioAcesso.horarioInicio += ':00'
      this.horarioAcesso.horarioFim += ':00'
      if(!this.horarioAcesso.diaDaSemana) {
        this.$message.warning("Selecione um dia da semana");
        return;
      }
      if(!this.horarioAcesso.horarioInicio || !this.horarioAcesso.horarioFim) {
        this.$message.warning("Selecione um horário");
        return;
      }
      if(
        !Util.validarHora(this.horarioAcesso.horarioInicio) ||
        !Util.validarHora(this.horarioAcesso.horarioFim)
        ) {
          this.$message.warning("Selecione um horário válido");
          return;
        }
      if(!Util.validarIntervaloDeHora(this.horarioAcesso.horarioInicio, this.horarioAcesso.horarioFim)) {
        this.$message.warning("O horário inicial deve ser anterior ao horário final");
        return;
      }
      let payload = Object.assign({}, this.horarioAcesso);
      this.usuario.horariosDeAcesso.push(payload);
      this.horarioAcesso.horarioInicio = '';
      this.horarioAcesso.horarioFim = '';
    },

    removerHorarioAcesso(horarioAcesso) {
      this.usuario.horariosDeAcesso = this.usuario.horariosDeAcesso
        .filter((item) => {
          return item != horarioAcesso;
        });
    },

    cancelar() {
      this.close();
    },

    close() {
      this.$emit('close');
    },
  },
}
</script>

<style>

</style>